import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../state'

/** Component for displaying the general section of a cluster. */
@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.value.Component,
    ds.loader.Component,
  ],
  selector: 'atn-space-cluster-general',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.dms.schema.Feature} */
  private readonly _schemaFeature = ngCore.inject(state.dms.schema.Feature)

  /** @see {@link state.space.organizations.Feature} */
  private readonly _organizationsFeature = ngCore.inject(
    state.space.organizations.Feature,
  )

  /** @see {@link state.space.full.clusters.Collection} */
  public readonly clustersEc = ngCore.inject(
    state.space.full.clusters.Collection,
  )

  /** Selected cluster */
  private readonly _clusterSg = ngCore.computed(() =>
    this.clustersEc.plugins.currentEntityPlugin.feature.selectors
      .getEntity()
      .asSignal(),
  )

  /** Selected cluster id */
  public readonly clusterIdSg = ngCore.computed(
    (cluster = this._clusterSg()) => cluster?.id,
  )

  /** Selected cluster name */
  public readonly clusterNameSg = ngCore.computed(
    (cluster = this._clusterSg()) => cluster?.name,
  )

  /** Selected cluster description */
  public readonly clusterDescriptionSg = ngCore.computed(
    (cluster = this._clusterSg()) => cluster?.description,
  )

  /** Selected cluster comment */
  public readonly clusterCommentSg = ngCore.computed(
    (cluster = this._clusterSg()) =>
      cluster?.comment?.trim() ? cluster.comment.trim() : undefined,
  )

  /** Organization entity name and selected organization display name */
  public readonly organizationDataSg = ngCore.computed(
    (
      cluster = this._clusterSg(),
      schema = this._schemaFeature.selectors.schema.asSignal(),
    ) => {
      if (!cluster) {
        return []
      }

      return schema
        .getEntitiesInDimension(
          state.space.organizations.constants.DIMENSION_ID,
        )
        .map(entity => {
          const orgEc = this._organizationsFeature.selectors
            .getOrganizationEc(entity.id)
            .asSignal()

          const organizationId = cluster.organization?.[entity.id]

          const value =
            organizationId &&
            orgEc?.plugins.cachePlugin.feature.selectors
              .getCachedEntity(organizationId)
              .asSignal()?.name

          return {
            id: entity.id,
            name: entity.name,
            value,
          }
        })
    },
  )

  /** Open the edit modal for the current cluster */
  public editClickHandler(): void {
    const source = 'ClusterGeneral.Edit.Clicked'
    if (
      this.clustersEc.plugins.currentEntityPlugin.feature.selectors
        .isEditing()
        .asSignal()
    ) {
      this.clustersEc.plugins.editingPlugin.feature.actions.discard
        .from(source)
        .dispatch({ current: true })
    }

    this.clustersEc.plugins.editingPlugin.feature.actions.edit
      .from(source)
      .dispatch({ id: this.clusterIdSg() })
  }
}
